export default {
  data() {
    return {}
  },
  fomatDate(time) {
    const date = new Date(time)
    const Y = date.getFullYear()
    const M = date.getMonth() + 1
    const D = date.getDate()
    return `${Y}年-${M}月-${D}日`
  }
}
